<template>
  <footer>
    <nav class="footmenu">
      <ul>
        <li>
          <a href="javascript: false" @click="fnModalAlert(1)">이용약관</a>
        </li>
        <li>
          <a href="javascript: false" @click="fnModalAlert(2)">개인정보처리방침</a>
        </li>
      </ul>
    </nav>
    <div class="footer">
      <!-- 고객센터 -->
      <div class="footer-cc">
        <h3>고객센터</h3>
        <div class="footer-call">1688-0724</div>
        <div class="footer-time">평일 오전 9시 ~ 오후 6시 <span>(점심시간 오후 12시 ~ 오후 1시)</span></div>
      </div>

      <!-- 카피라이터 -->
      <dl class="footer-copyright">
        <dt class="co-name">㈜뱅크다이어리</dt>
        <dd class="rep-name">대표자 김승욱</dd>

        <dt>주소</dt>
        <dd>부산광역시 해운대구 센텀중앙로 90 401호</dd>

        <dt>메일</dt>
        <dd>cs@bankdiary.net</dd>

        <dt>사업자번호</dt>
        <dd>
          851-88-02404
          <!--          <button class="btn-biz-num">사업자 정보 확인 &gt;</button>-->
        </dd>

        <!--        <dt>통신판매업신고</dt>-->
        <!--        <dd>2020-대구수성구-0001</dd>-->
      </dl>
    </div>
  </footer>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { useStore } from 'vuex';

const modalState = () => {
  const { proxy } = getCurrentInstance();
  const store = useStore();

  const getMapTerms = async (termsCategoryNo = 1) => {
    return await proxy.$CommonSvc.getMapTerms({
      termsCategoryNo
    });
  };

  const fnModalAlert = async (type = 1) => {
    const payload = {};
    payload.component = proxy.$modalAlertNames.TERMS;
    payload.layout = {};
    payload.data = await getMapTerms(type);
    store.dispatch('layout/pushModalAlertComponent', payload);
  };

  return { fnModalAlert };
};

export default {
  name: 'footer-bar-index',
  setup() {
    return {
      ...modalState()
    };
  }
};
</script>

<style scoped></style>
